import { render, staticRenderFns } from "./Dunning.vue?vue&type=template&id=596e64c4&scoped=true&"
import script from "./Dunning.vue?vue&type=script&lang=js&"
export * from "./Dunning.vue?vue&type=script&lang=js&"
import style0 from "./Dunning.vue?vue&type=style&index=0&id=596e64c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596e64c4",
  null
  
)

export default component.exports